import React, { useState } from 'react'
import { Text } from '@amzn/storm-ui'
import { StandardModal, ModalProps } from '@amzn/aapn-react-components'
import { StyledAlertWithMargin } from '../../manage_shared.styles'
import { CellProps } from 'react-table'
import { Lens } from 'monocle-ts'
import { ExecutionResult } from 'graphql'
import {
  RemovePartnerAdvertiserMutation,
  RemovePartnerAdvertiserMutationVariables,
  DeletePartnerAdvertiserInviteMutation,
  DeletePartnerAdvertiserInviteMutationVariables,
} from 'generated/graphql'
import { MutationFunctionOptions, MutationHookOptions, MutationTuple } from '@apollo/client'
import { AdvertisersModalText } from './manage_advertisers_v2.styles'

interface AdvertisersDeleteHeaderProps {
  headerLabel: string
}

export const AdvertisersDeleteHeader: React.FunctionComponent<AdvertisersDeleteHeaderProps> = (props: AdvertisersDeleteHeaderProps): JSX.Element => {
  const { headerLabel } = props
  return (
    <Text fontSize={'medium'}>
      <strong>{headerLabel}</strong>
    </Text>
  )
}

interface DeleteModalProps {
  deleteLabel: JSX.Element
  callToActionLabel: string
  cancelLabel: string
  loadingLabel: string
  sendLabel: string
  header: JSX.Element
  removeErrorMessage: string
  isHidden?: boolean
}

export interface AdvertiserInvitesDeleteModalProps extends DeleteModalProps {
  inviteToken: string
  inviteeEmail: string
  onSetData: (
    deleteAdvertiserInvite: (
      options?: MutationFunctionOptions<DeletePartnerAdvertiserInviteMutation, DeletePartnerAdvertiserInviteMutationVariables>,
    ) => Promise<ExecutionResult<DeletePartnerAdvertiserInviteMutation>>,
  ) => Promise<void>
  deleteMutationHook: (
    baseOptions?: MutationHookOptions<DeletePartnerAdvertiserInviteMutation, DeletePartnerAdvertiserInviteMutationVariables>,
  ) => MutationTuple<DeletePartnerAdvertiserInviteMutation, DeletePartnerAdvertiserInviteMutationVariables>
}

export interface AdvertisersUnlinkModalProps extends DeleteModalProps {
  partnerId: string
  advertiserId: string
  advertiserName: string
  onSetData: (
    deleteAdvertiserInvite: (
      options?: MutationFunctionOptions<RemovePartnerAdvertiserMutation, RemovePartnerAdvertiserMutationVariables>,
    ) => Promise<ExecutionResult<RemovePartnerAdvertiserMutation>>,
  ) => Promise<void>
  deleteMutationHook: (
    baseOptions?: MutationHookOptions<RemovePartnerAdvertiserMutation, RemovePartnerAdvertiserMutationVariables>,
  ) => MutationTuple<RemovePartnerAdvertiserMutation, RemovePartnerAdvertiserMutationVariables>
}

export const AdvertisersDeleteModal: React.FunctionComponent<CellProps<ModalProps>> = (props: CellProps<ModalProps>): JSX.Element => {
  const [sendError, setSendError] = useState(false)

  const [deleteMutationFn, { data, loading }] = props.cell.value.deleteMutationHook({})

  const assignedModalProps = {
    callToActionLabel: props.cell.value.callToActionLabel,
    cancelLabel: props.cell.value.cancelLabel,
    loadingLabel: props.cell.value.loadingLabel,
    sendLabel: props.cell.value.sendLabel,
    onSetData: () => {
      props.cell.value.onSetData(deleteMutationFn).catch(() => {
        setSendError(true)
      })
    },
    onOpen: () => {
      setSendError(false)
    },
    header: props.cell.value.header,
    isLoading: loading,
    isSuccess: !!data,
  }

  const propValues = Lens.fromPath<CellProps<ModalProps>>()(['cell', 'value'])

  return (
    <>
      {!props.cell.value.isHidden && (
        <StandardModal {...propValues.set(assignedModalProps)(props)}>
          <StyledAlertWithMargin withCloseButton isOpen={sendError} onClose={() => setSendError(false)}>
            {props.cell.value.removeErrorMessage}
          </StyledAlertWithMargin>
          <AdvertisersModalText>{props.cell.value.deleteLabel}</AdvertisersModalText>
        </StandardModal>
      )}
    </>
  )
}
